import { Search, X } from 'lucide-react';

export default function SearchBar({
  searchTerm,
  onSearchChange,
  filterStatus,
  onFilterChange,
  sortBy,
  onSortChange,
}) {
  return (
    <div className="gm-search-bar">
      {/* Search */}
      <div className="gm-search-input-wrap">
        <Search className="gm-search-icon" />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => onSearchChange(e.target.value)}
          placeholder="Search groups by name or description..."
          className="gm-search-input"
        />
        {searchTerm && (
          <button
            onClick={() => onSearchChange('')}
            className="gm-search-clear"
          >
            <X size={14} />
          </button>
        )}
      </div>

      {/* Filter: Status */}
      <select
        value={filterStatus}
        onChange={(e) => onFilterChange(e.target.value)}
        className="gm-filter-select"
      >
        <option value="all">All Status</option>
        <option value="active">Active</option>
        <option value="inactive">Inactive</option>
      </select>

      {/* Sort */}
      <select
        value={sortBy}
        onChange={(e) => onSortChange(e.target.value)}
        className="gm-filter-select"
      >
        <option value="name">Sort: Name</option>
        <option value="users">Sort: Users</option>
        <option value="commission">Sort: Commission</option>
        <option value="created">Sort: Created</option>
      </select>
    </div>
  );
}
